import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectMenu } from '@local/web-design-system/dist/components/SelectMenu';
import Grid from '@mui/material/GridLegacy';
import { createElement, useEffect, useState } from 'react';
import { useStyles } from './OrgHubSelectMenu.styles';
export const OrgHubSelectMenu = ({ options = [], optionGroups, onSelected, defaultValue, value, variant = 'dark', width, topSpacing, }) => {
    const { classes } = useStyles({ variant, width, topSpacing });
    const [selectedOption, setSelectedOption] = useState(defaultValue);
    useEffect(() => {
        if (defaultValue) {
            onSelected(defaultValue);
            setSelectedOption(defaultValue);
        }
    }, [defaultValue]);
    function triggerSelected(selectedValue) {
        if (defaultValue !== undefined) {
            setSelectedOption(selectedValue);
        }
        onSelected(selectedValue);
    }
    function prefixOptionGroupLabel(option) {
        if (!optionGroups) {
            return undefined;
        }
        const filteredOptions = optionGroups.find((optionGroup) => optionGroup.optionIds.some((optionId) => optionId === option));
        if (!filteredOptions) {
            return undefined;
        }
        const { label } = filteredOptions;
        return `${label}`;
    }
    function filterDisplayNames(item) {
        return item.replace(/\b(Central Server - )\b/g, '');
    }
    function selectMenuItems() {
        const optionList = [];
        options.forEach((item) => {
            const OptionGroup = prefixOptionGroupLabel(item.key);
            optionList.push({
                key: item.key,
                label: () => selectMenuComponentItem(OptionGroup, typeof item.label === 'string'
                    ? filterDisplayNames(item.label)
                    : item.label),
            });
        });
        return optionList;
    }
    function selectMenuComponentItem(OptionGroup, option) {
        return (_jsxs(Grid, { container: true, direction: "column", alignItems: "flex-start", children: [OptionGroup && (_jsx(Grid, { className: classes.textAlign, onMouseOver: applyTitleIfEllipsisItems, onFocus: applyTitleIfEllipsisItems, item: true, children: _jsx("span", { className: "optionGroup", children: OptionGroup }) })), _jsx(Grid, { className: classes.textAlign, onMouseOver: applyTitleIfEllipsisItems, onFocus: applyTitleIfEllipsisItems, item: true, children: typeof option === 'string' ? (_jsx("span", { className: "option", children: option })) : (createElement(option)) })] }));
    }
    function applyTitleIfEllipsisItems(e) {
        if (e.target.scrollWidth > e.target.clientWidth) {
            e.target.parentElement.parentElement.parentElement.setAttribute('title', e.target.innerText);
        }
    }
    function applyTitleIfEllipsisOptionGroups(e) {
        if (e.target instanceof HTMLLIElement && e.target.role == null) {
            if (e.target.scrollWidth > e.target.clientWidth) {
                e.target.setAttribute('title', e.target.innerText);
            }
        }
    }
    return (_jsx("div", { onMouseOver: applyTitleIfEllipsisOptionGroups, onFocus: applyTitleIfEllipsisOptionGroups, children: _jsx(SelectMenu, { options: selectMenuItems(), optionGroups: optionGroups, onSelect: (key) => triggerSelected(key.toString()), defaultValue: selectedOption, value: value, classes: {
                button: classes.selectMenuButton,
                paper: classes.selectPaper,
                menuItem: classes.selectMenuItem,
                menuLabel: classes.selectMenuLabel,
                labelContainer: classes.labelContainer,
            }, applyTraceMessage: "option" }) }));
};
//# sourceMappingURL=OrgHubSelectMenu.js.map